export default function usePaginator() {
  function paginate(list: Array<any>, perPage: number, page: number) {
    const offset = (page - 1) * perPage;

    return list.slice(offset, offset + perPage);
  }

  function calculatePages(list: Array<any>, perPage: number) {
    if (list.length === 0) return 0;

    return Math.ceil(list.length / perPage);
  }

  return {
    paginate,
    calculatePages,
  };
}
